var scrollpos = window.scrollY;
//var mainMenu = document.getElementById("MainMenu");
//var mobileMenu = document.getElementById("MobileMenu");
var header = document.getElementById("shopify-section-header");

function add_class_on_scroll() {
    //mainMenu.classList.add("sticky-on");
    //mobileMenu.classList.add("sticky-on");
    header.classList.add("sticky-on");
}

function remove_class_on_scroll() {
    //mainMenu.classList.remove("sticky-on");
    //mobileMenu.classList.remove("sticky-on");
    header.classList.remove("sticky-on");
}

window.addEventListener('scroll', function(){ 
    scrollpos = window.scrollY;

    if(scrollpos > 100){
        add_class_on_scroll();
    }
    else {
        remove_class_on_scroll();
    }
    //console.log(scrollpos); 
});



function showPop(){
  
  if(document.documentElement.clientWidth > 784) {
    $('.stitching-popup').addClass('pop-over');
    //$('.tab-label.stitching').trigger('click');
    $('.mw-option[style="display: block;"] *').removeClass('temp-hide');

    if(!$('.close-pop-over').length){
      $('.pop-over').after('<div class="close-pop-over stitch-pop">Close</div>');
    }
    if(!$('.bg-pop-over').length){
      $('.close-pop-over').after('<div class="bg-pop-over stitch-pop"></div>');
    }
  }
}

function closePop(){
  $('.mw-option[style="display: block;"] *').addClass('temp-hide');
  $('.stitching-popup').removeClass('pop-over');
  $('label[for="pdp-tabone"]').trigger('click');
  $('.stitch-pop').remove();
}

function validatePop(){
  setTimeout(function(){ 
    if($('span.validation-error').length){
      showPop();
    } 
  },1000);
}

jQuery(function (){
  
  $('body').on('click','cart-remove-button .button',function(e){
    let removeId = $(this).data('line');
    //alert(removeId);
      setTimeout(function(){
        $('cart-remove-button .button.customized-'+removeId).trigger('click');
      },2000)
  });


  jQuery('body').on('click','.customer .tabs input[type=radio]',function(){
    localStorage.setItem('activeTab',jQuery(this).attr('id'));
  });
  
  const getActiveTab = localStorage.getItem("activeTab");
  if(getActiveTab) {
    jQuery('.customer .tabs input#'+getActiveTab).trigger('click');
    localStorage.removeItem('activeTab');
  }

});


/*pdp image zoom*/

  $(document).ready(function(){
    $('.image-zoom')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });
  });


/*read more*/
const readMoreBtns = document.querySelectorAll('.read-more-toggle');
  readMoreBtns.forEach((btn) => {
  btn.addEventListener('click', function() {
      const readMoreContainer = this.parentNode;
      readMoreContainer.classList.toggle('open');
      this.classList.toggle('open');
      this.setAttribute('aria-expanded', this.classList.contains('open'));
      const buttonText = this.classList.contains('open') ? 'Read less' : 'Read more';
      this.textContent = buttonText;
  });
});

/* facet mobile fix */
$('.facets__disclosure').on('click',function(){
    let widthPx = Math.floor(window.innerWidth);
    if(widthPx <= 650){
      let closetFacet = $(this).find('div.facets__display');
      let leftPx = Math.floor(closetFacet.offset().left + 12);
      closetFacet.css({"left":"-"+leftPx+"px","width":widthPx+"px"});
    }
});

$('body').on('click','.filter-toggle-mobile',function(){
  $('.collection-facets').removeClass('small-hide');
})
$('body').on('click','.filter-close',function(){
  $('.collection-facets').addClass('small-hide');
})
$('body').on('click','#showAllResults',function(){
  $('.collection-facets').addClass('small-hide');
})
$('body').on('click','#clearAllFilters',function(){
  $('.collection-facets').addClass('small-hide');
})

const tabs = document.querySelectorAll('.tab');
const content = document.querySelectorAll('.content');

tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            // Remove active class from all tabs
            tabs.forEach(t => t.classList.remove('active'));
            // Add active class to the clicked tab
            this.classList.add('active');

            // Hide all content
            content.forEach(c => c.classList.add('hidden', 'show'));
            // Show content corresponding to the clicked tab
            const targetContent = document.querySelector(`.${this.id}-content`);
            targetContent.classList.remove('hidden');
        });
    });

